import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { OverlayTrigger } from 'react-bootstrap';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookBFFInspectionTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          bff_tool_fod_ok: 'false',
          bff_tool_fod_na: 'false',
          aircraft_logbook_id: this.props.aircraft_logbook_id,
          id: '',
          approvals: [],
          approval: [],
          inspections: '',
          modal_justification: false,
        };
        this.edit = this.edit.bind(this);
        this.reopen = this.reopen.bind(this);
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }
      
      handleToggleChange (name, event) {
        var change = {};
        if (event.target.checked === true) {
          var value = 1;
        } else {
          var value = 0;
        }
        change[name] = value;
        this.setState(change);
      }

      handleCheckboxChange(name, event) {
        if(event.target.checked === false) {
          this.setState({
            bff_tool_fod_ok: false,
            bff_tool_fod_na: false,
          });
          var datasave = {
            aircraft_logbook_id: this.state.aircraft_logbook_id,
            inspection_type: 'bff',
            id: this.state.inspections.id,
            bff_tool_fod_na: false,
            bff_tool_fod_ok: false,
          };
        } else {
          this.setState({
            bff_tool_fod_ok: true,
            bff_tool_fod_na: false,
          });
          var datasave = {
            aircraft_logbook_id: this.state.aircraft_logbook_id,
            inspection_type: 'bff',
            id: this.state.inspections.id,
            bff_tool_fod_na: false,
            bff_tool_fod_ok: true,
          };
        }
        this.edit(datasave);
      }
      handleCheckboxNaChange(name, event) {
        if(event.target.checked === false) {
          this.setState({
            bff_tool_fod_ok: false,
            bff_tool_fod_na: false,
          });
          var datasave = {
            aircraft_logbook_id: this.state.aircraft_logbook_id,
            inspection_type: 'bff',
            id: this.state.inspections.id,
            bff_tool_fod_na: false,
            bff_tool_fod_ok: false,
          };
        } else {
          this.setState({
            bff_tool_fod_ok: false,
            bff_tool_fod_na: true,
          });
          var datasave = {
            aircraft_logbook_id: this.state.aircraft_logbook_id,
            inspection_type: 'bff',
            id: this.state.inspections.id,
            bff_tool_fod_na: true,
            bff_tool_fod_ok: false,
          };
        }
        this.edit(datasave);
      }
    
      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            loaded: 1,
          });
        }

        if(typeof newProps.inspections !== 'undefined' && newProps.inspections !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            inspections: newProps.inspections,
            id: newProps.inspections.id,
            bff_tool_fod_ok: newProps.inspections.bff_tool_fod_ok,
            bff_tool_fod_na: newProps.inspections.bff_tool_fod_na,
          });
        }

        if(typeof newProps.approvals[2] !== 'undefined' && newProps.approvals[2] !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            approvals: newProps.approvals[2],
            approval: newProps.approvals[2][0],
          });
        }
      }
    
      // Fetch salvando a edição
      edit(datasave) {
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/inspecao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch((error) => {
            console.error(error);
          });
        });

      }

      reopen(event) {
        event.preventDefault();
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var datasave = {
          id: this.state.id,
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          justification: this.state.justification,
          inspection_type: 'bff',
          approval_type: this.state.approval.type,
        };
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/inspecao/reabrir', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({ modal_justification: false, justification: null });
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    
      render() {
        var self = this;
        return (
    <div>
      <RequestApi ref={'request_api'} />
      <div className="row">
        <div className="col-md-1 text-center">
          {
            (self.state.approval.status === 1) ?
              <button onClick={() => self.setState({ modal_justification: true })} className="btn btn-primary"><i className="fa fa-fw fa-refresh"></i></button>
            :
              <button onClick={() => {self.props.approve(self.state.approval.id, self.state.approval.type)}} className="btn btn-success"><i className="fa fa-check"></i></button>
          }
        </div>
        <div className="col-md-4">
          <h3 className="page-title pull-left">Before First Flight (BFF) Inspection</h3>
          <div className="clearfix"></div>
        </div>
        <div className="col-md-3">
          <form onSubmit={this.edit}>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>Tool/FOD</label>
                  <br></br>
                  <label>
                    <input
                      name="bff_tool_fod_ok"
                      type="checkbox"
                      checked={this.state.bff_tool_fod_ok}
                      onChange={this.handleCheckboxChange.bind(this, 'bff_tool_fod_ok')} 
                    />
                    &nbsp;OK
                  </label>
                  &nbsp;
                  <label>
                    <input
                      name="bff_tool_fod_na"
                      type="checkbox"
                      checked={this.state.bff_tool_fod_na}
                      onChange={this.handleCheckboxNaChange.bind(this, 'bff_tool_fod_na')} 
                    />
                    &nbsp;N/A
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-4">
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
              <caption>Approval</caption>
              <thead>
                <tr className="text-center">
                  <th>User</th>
                  <th>Status</th>
                  <th>Approval Date</th>
                </tr>
              </thead>
              <tbody id="bff_check_approvals">
              {self.state.approvals.map(function(k) {
                var approval = k;
                return(
                  <tr className="text-center" key={approval.id}>
                    {
                      (approval.user_id !== 'undefined' && approval.user_id !== null) ?
                      <td>{approval.user_name}</td>
                      :
                      <td></td>
                    }
                    <td>{approval.status_str}</td>
                    <td>{approval.approval_date_str}</td>
                  </tr>
                );
              })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <hr/>
      {/* Modal de justificativa para reabertura */}
      <Modal show={this.state.modal_justification} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4 className="pull-left"><strong>Please tell us why you need to reopen this inspection</strong></h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_justification: false, justification: null})}><i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <p className="alert alert-danger">Attention: This reopening should only be used in case of filling errors. For a new inspection after changing the aircraft's conditions, please open a new logbook.</p>
          <form onSubmit={this.reopen}>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>Justification:</label>
                  <textarea style={{ height: 200 }} type="text" name="justification" required className="form-control" value={this.state.justification} onChange={this.handleChange.bind(this, 'justification')} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-certificate"></i> Submit justification</button>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_justification: false, justification: null})}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </div>
    );
  }
}

export default AircraftLogbookBFFInspectionTab;


// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookBFFInspectionTab.js